import { BaseService } from 'components/base/base-service';
import api from 'libs/axios/api';
import { apiService } from 'libs/axios/services';

export const updateTaskHistoryFetcher = async (data: {
    body: ITaskHistoryUpdate;
    item_id: string;
}): Promise<ApiResponse<any>> => {
    return apiService.put<ITaskHistoryUpdate, ITaskHistoryRes>(
        `${api.taskHistory}/${data.item_id}`,
        data.body,
        undefined,
        true,
    );
};

export const downloadTaskHistoryFetcher = async (
    request: URLSearchParams,
): Promise<ApiResponse<any>> => {
    return apiService.get<URLSearchParams, ResponseBase<any>>(api.taskHistoryDownload, request, {
        responseType: 'blob',
    });
};

export abstract class IHistoryTaskService extends BaseService<ITaskHistory> {}

export class TaskHistoryService extends IHistoryTaskService {
    notFoundMessage = 'History task not found';
    path = '/task-history';

    getById(_id: string): Promise<ITaskHistory> {
        throw new Error('Method not implemented.');
    }
    create(_data: Partial<ITaskHistory>): Promise<ITaskHistory> {
        throw new Error('Method not implemented.');
    }
    update(_id: string, _data: Partial<ITaskHistory>): Promise<ITaskHistory> {
        throw new Error('Method not implemented.');
    }
    deleteAll(_ids: string[]): Promise<ITaskHistory[]> {
        throw new Error('Method not implemented.');
    }
    deleteById(_id: string): Promise<void> {
        throw new Error('Method not implemented.');
    }

    getAll(request: TaskHistoryListRequest): Promise<ApiResponse<ResponseBase<ITaskHistory[]>>> {
        return apiService.get<TaskHistoryListRequest, ResponseBase<ITaskHistory[]>>(
            `${this.path}/list`,
            request,
            undefined,
            true,
        );
    }

    downloadCSV(_params?: URLSearchParams): Promise<ApiResponse<any>> {
        throw new Error('Method not implemented.');
    }
}
